module.exports = __webpack_public_path__ + "assets/dfe6e568e3595d35cb30523b4e06be35.woff2";